import { render, staticRenderFns } from "./icorObjectEdit.vue?vue&type=template&id=5ec192bf&scoped=true&"
import script from "./icorObjectEdit.vue?vue&type=script&lang=js&"
export * from "./icorObjectEdit.vue?vue&type=script&lang=js&"
import style0 from "./icorObjectEdit.vue?vue&type=style&index=0&id=5ec192bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec192bf",
  null
  
)

component.options.__file = "icorObjectEdit.vue"
export default component.exports